import Layout from "./Shared/Layout";
import Breadcrumb from "./Breadcrumb";

const RefundandReturnPolicy = () => {

    return (
        <Layout showBreadcrumb={false}>
            <section className="contact-banner-sec">
                <div className="container-fluid">
                    <div className="page-header">
                        <h1>Refund & ReturnPolicy</h1>
                    </div>
                    <Breadcrumb currentLabel="Refund & ReturnPolicy" />
                </div>
            </section>
            <section>
                <div className="container">
                    <div className="privacy_policy_wepper">
                        {/* Section 1 */}
                        <div className="privacy_policy_inner">
                            <h2>MU Gems Jewelry - Refund & ReturnPolicy</h2>
                            <p>
                                Acceptance of Terms
                                By accessing and purchasing from MU Gems Jewelry, you agree to comply with the Refund & ReturnPolicy outlined below. These terms govern your use of our website, services, and products.
                            </p>
                        </div>

                        {/* Section 2 */}
                        <div className="privacy_policy_inner">
                            <h2>Products & Orders</h2>
                            <p>
                                MU Gems Jewelry products are handcrafted with care; slight variations may occur due to the nature of materials used.
                            </p>
                            <ul>
                                <li>All orders are subject to availability and confirmation of payment.</li>
                                <li>We reserve the right to refuse or cancel any order at our discretion if payment verification fails or stock is unavailable.</li>

                            </ul>
                        </div>

                        {/* Section 3 */}
                        <div className="privacy_policy_inner">
                            <h2>Pricing & Payments</h2>
                            <ul>
                                <li>Prices listed on the website are in [Currency] and inclusive of applicable taxes unless stated otherwise.</li>
                                <li>Payment must be made via approved payment methods at the time of order.</li>
                                <li>Prices are subject to change without prior notice. However, confirmed orders will not be affected by price changes.</li>
                            </ul>
                        </div>

                        {/* Section 4 */}
                        <div className="privacy_policy_inner">
                            <h2>Shipping & Delivery</h2>

                            <ul>
                                <li>
                                    MU Gems Jewelry ships to [specify locations]. Shipping charges and estimated delivery timelines are displayed at checkout.
                                </li>
                                <li>Delays due to unforeseen circumstances, such as courier delays or natural calamities, are not the responsibility of MU Gems.</li>
                                <li>
                                    International orders may incur customs duties, which must be borne by the customer.
                                </li>
                            </ul>
                        </div>

                        {/* Section 5 */}
                        <div className="privacy_policy_inner">
                            <h2>Returns, Exchanges & Refunds</h2>
                            <p>Products can be returned or exchanged within [X days] of delivery if they meet the following conditions:</p>
                            <ul>
                                <li>
                                    The item is unused, undamaged, and in its original packaging.
                                </li>
                                <li>
                                    A valid proof of purchase is provided.
                                </li>
                                <li>
                                    Refunds (if applicable) will be processed after the returned item is received and inspected.
                                </li>
                                <li>
                                    <strong>Accuracy:</strong> Data is accurate, kept up-to-date, and
                                    corrected promptly if inaccurate.
                                </li>
                                <li>
                                    Custom or personalized orders are non-refundable.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default RefundandReturnPolicy;
